import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CtaButton } from '../components/CtaButton';
import { posts } from '../data/posts';
export function Blog() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Insights — Branding, Web & Marketing | Yetu Design Lab';
  }, []);
  const [featured, ...rest] = posts;
  return <>
      <div className="glow" data-id="element-293"></div>
      <Navbar data-id="element-294" />

      <main className="wrap" data-id="element-295">
        <section className="sec pb-0" data-id="element-296">
          <div className="eyebrow mb-6" data-id="element-297">Insights</div>
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-6" data-id="element-298">
            Thoughts on <span className="serif" data-id="element-299">design</span> & growth.
          </h1>
          <p className="text-xl text-mut max-w-2xl leading-relaxed" data-id="element-300">
            Practical perspectives on branding, web design, marketing, and how a
            senior studio actually ships work — from the team at Yetu Design
            Lab.
          </p>
        </section>

        {/* Featured lead article */}
        <section className="sec pb-0" data-id="element-301">
          <Link to={`/blog/${featured.slug}`} className="group block border border-line rounded-r-lg bg-raise overflow-hidden p-8 md:p-12 transition-colors hover:border-line-2" data-id="element-302">
            <div className="flex flex-wrap items-center gap-3 mb-5 mono text-xs uppercase tracking-wider" data-id="element-303">
              <span className="text-lime" data-id="element-304">{featured.category}</span>
              <span className="text-mut-2" data-id="element-305">•</span>
              <span className="text-mut-2" data-id="element-306">{featured.readTime}</span>
              <span className="ml-auto text-mut-2 normal-case tracking-normal font-semibold text-sm inline-flex items-center gap-1 group-hover:text-lime transition-colors" data-id="element-307">
                Read article <ArrowRight size={15} data-id="element-308" />
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-4 max-w-3xl group-hover:text-lime transition-colors" data-id="element-309">
              {featured.title}
            </h2>
            <p className="text-lg text-mut max-w-2xl leading-relaxed" data-id="element-310">
              {featured.excerpt}
            </p>
          </Link>
        </section>

        {/* Article grid */}
        <section className="sec" data-id="element-311">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-312">
            {rest.map(post => <Link key={post.slug} to={`/blog/${post.slug}`} className="group border border-line rounded-r-lg bg-raise p-7 flex flex-col gap-4 transition-all hover:border-line-2 hover:-translate-y-1" data-id="element-313">
                <div className="flex items-center gap-3 mono text-xs uppercase tracking-wider" data-id="element-314">
                  <span className="text-lime" data-id="element-315">{post.category}</span>
                  <span className="text-mut-2" data-id="element-316">•</span>
                  <span className="text-mut-2" data-id="element-317">{post.readTime}</span>
                </div>
                <h3 className="text-2xl font-bold tracking-tight group-hover:text-lime transition-colors" data-id="element-318">
                  {post.title}
                </h3>
                <p className="text-mut leading-relaxed flex-1" data-id="element-319">
                  {post.excerpt}
                </p>
                <span className="mono text-xs uppercase tracking-wider text-ink inline-flex items-center gap-1.5 group-hover:text-lime transition-colors" data-id="element-320">
                  Read more <ArrowRight size={14} data-id="element-321" />
                </span>
              </Link>)}
          </div>
        </section>

        {/* Lead CTA band */}
        <section className="sec pt-0" data-id="element-322">
          <div className="border border-line-2 rounded-r-lg bg-raise-2 p-10 md:p-14 text-center flex flex-col items-center" data-id="element-323">
            <div className="eyebrow mb-5" data-id="element-324">Free consultation</div>
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-5 max-w-2xl" data-id="element-325">
              Ready to put these ideas to <span className="serif" data-id="element-326">work</span>?
            </h2>
            <p className="text-lg text-mut max-w-xl mb-9 leading-relaxed" data-id="element-327">
              Tell us where you want to grow. We'll come back with a clear,
              honest view on the fastest path there — no obligation.
            </p>
            <CtaButton to="/#contact" variant="pill" data-id="element-328">
              Book Free Consultation
            </CtaButton>
          </div>
        </section>
      </main>

      <Footer data-id="element-329" />
    </>;
}